<template>
  <div>
    <vx-card id="outboundDataContainer" class="mb-8 vs-con-loading__container">
      <div class="vs-component vs-con-table vs-table-primary mb-2">
        <header class="header-table vs-table--header"></header>
        <div class="con-tablex vs-table--content">
          <div class="vs-con-tbody vs-table--tbody">
            <table class="vs-table vs-table--tbody-table no-hover">
              <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                <td class="td vs-table--td" v-text="$t('queue_status_incoming_phone_number')"></td>
                <td class="td vs-table--td">
                  <vx-input-group>
                    <vs-input v-model="exten"/>
                    <template slot="append">
                      <div class="append-text btn-addon">
                        <vs-button color="primary" type="border" size="small" @click="exten = ''">{{ $t('queue_status_reset') }}</vs-button>
                      </div>
                    </template>
                  </vx-input-group>
                </td>
                <td class="td vs-table--td">
                  <vs-button color="primary" type="filled" style="min-width:136px;" @click="makeACall">{{ $t('queue_status_make_a_call') }}</vs-button>
                </td>
              </tr>
              <tr class="tr-values vs-table--tr tr-table-state-null hoverFlat">
                <td class="td vs-table--td" v-text="$t('queue_status_caller_id')"></td>
                <td class="td vs-table--td">
                  <vx-input-group>
                    <vs-input disabled v-model="selected.callerId"/>
                    <template slot="append">
                      <div class="append-text btn-addon">
                        <vs-button color="primary" type="border" size="small" @click="reset">{{ $t('queue_status_reset') }}</vs-button>
                      </div>
                    </template>
                  </vx-input-group>
                </td>
                <td class="td vs-table--td">
                  <vs-button color="danger" type="filled" style="min-width:136px;" :disabled="hangupStatus" @click="hangUp">{{ $t('queue_status_hangup') }}</vs-button>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div class="vs-component vs-con-table hoverFlat vs-table-primary" v-if="companyQueueStatuses && companyQueueStatuses.length">
        <header class="header-table vs-table--header"></header>
        <div class="con-tablex vs-table--content">
          <div class="vs-con-tbody vs-table--tbody">
            <table class="vs-table vs-table--tbody-table">
              <thead class="vs-table--thead">
                <tr>
                  <th colspan="1" rowspan="1" class="text-center" v-text="$t('queue_status_call_id_sequence')"></th>
                  <th colspan="1" rowspan="1" class="text-center" v-text="$t('queue_status_service_name')"></th>
                  <th colspan="1" rowspan="1" class="text-center" v-text="$t('queue_status_caller_id')"></th>
                </tr>
              </thead>
              <tr class="tr-values vs-table--tr clickable tr-table-state-null hoverFlat" v-for="(tr, indextr) in companyQueueStatuses" v-bind:key="indextr" @click="selectedRow(tr)" :class="`${selected.id === tr.id ? 'selected' : ''}`">
                <td class="td vs-table--td text-center" v-text="tr.callerNumber"></td>
                <td class="td vs-table--td text-center" v-text="tr.text"></td>
                <td class="td vs-table--td text-center" v-text="tr.callerId"></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
        <div v-text="$t('no_record')"></div>
      </vs-alert>
    </vx-card>
  </div>
</template>

<script>
import Cti from '@/models/Cti'
import CallerId from '@/models/CallerId'

export default {
  name: 'Window.OutboundPopup',
  data () {
    return {
      exten: typeof this.$route.params.phoneNumber !== 'undefined' ? this.$route.params.phoneNumber : '',
      loading: true,
      selected: {
        id: '',
        callerNumber: '',
        text: '',
        extension: ''
      },
      hangupStatus: true,
      channel: null,
      companyQueueStatuses: {}
    }
  },
  computed: {
    phoneNumber () {
      return this.$store.getters.phoneNumber
    },
    extension () {
      return this.$store.getters.extension
    },
    userContext () {
      return this.$store.getters.userInfo.context
    },
    servers () {
      return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.servers : {}
    }
  },
  mounted () {
    this.loadAllCallerIds()
  },
  methods: {
    async loadAllCallerIds () {
      this.$vs.loading({container: '#outboundDataContainer'})

      const response = await CallerId.displayAll()
      this.companyQueueStatuses = response.data

      this.$vs.loading.close('#outboundDataContainer > .con-vs-loading')
    },
    async makeACall () {

      if (this.exten.length <= 0) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'내선번호를 입력 하세요.',
          color:'danger',
          position:'top-right'
        })
        return false
      }

      const data = {
        exten: this.sanitizeDestinationNumber(this.exten),
        channel: this.extension,
        context: 0,
        callerid: this.selected.callerNumber
      }

      try {
        await Cti.customDial(this.servers.domain, data)
        this.getChannel(data.channel, data.exten)
      } catch (e) {
        this.$vs.notify({
          title:'CTI Notice',
          text: e.response,
          color:'danger',
          position:'top-right'
        })
      }
    },
    async getChannel (channel, exten) {

      try {
        const data = {
          extension: channel
        }
        const response = await Cti.getChannel(this.servers.domain, data)
        if (response.data.channel.length <= 0) {
          return false
        }
        this.channel = response.data.channel
        this.hangupStatus = false
        this.$vs.notify({
          title:'CTI Notice',
          text:`${exten} 로 전화를 걸었습니다.`,
          color:'danger',
          position:'top-right'
        })

      } catch (e) {
        this.$vs.notify({
          title:'CTI Notice',
          text: e.response,
          color:'danger',
          position:'top-right'
        })
      }

    },
    async hangUp () {
      try {

        const data = {
          channel: this.channel
        }

        Cti.hangupCustomDial(this.servers.domain, data)
        this.hangupStatus = true

      } catch (e) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'Hangup Error',
          color:'danger',
          position:'top-right'
        })
      }
    },
    sanitizeDestinationNumber (number) {
      return number.replace(/[^\w\s]/gi, '')
    },
    selectedRow (data) {
      this.selected = data
      // this.selected = data
    },
    reset () {
      this.selected = {
        id: '',
        callerNumber: '',
        text: '',
        extension: ''
      }
    }
  }
}
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
tr.selected {
  background-color: #dff0d8;
}

</style>
